import { render, staticRenderFns } from "./ExamImageVideo.vue?vue&type=template&id=91f84d4a&scoped=true"
import script from "./ExamImageVideo.vue?vue&type=script&lang=js"
export * from "./ExamImageVideo.vue?vue&type=script&lang=js"
import style0 from "./ExamImageVideo.vue?vue&type=style&index=0&id=91f84d4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91f84d4a",
  null
  
)

export default component.exports